export const DashboardQuickMapInfoField = {
    LastUpdate: 'lastUpdateTime',
    Address: 'address',
    Ignition: 'ignition',
    Freezer: 'freezer',
    Speed: 'speedStatus',
    Fuel: 'fuel',
    EngineHours: 'engineHours',
    Driver: 'driver',
    FuelCapStatus: 'fuelCapStatus',
    GpsBatteryLevel: 'gps.batteryLevel',
    BatteryCurrent: 'gps.batteryCurrent',
    MotionTime: 'gps.motionTime',

    get(value) {
        return this.all().find(x => x.value === value);
    },
    values() {
        return this.all().map(x => x.value);
    },
    all() {
        return [
            {
                value: DashboardQuickMapInfoField.LastUpdate,
                translationKey: 'dashboard.quick-map.info-window.last-update'
            },
            {
                value: DashboardQuickMapInfoField.Address,
                translationKey: 'dashboard.quick-map.info-window.address'
            },
            {
                value: DashboardQuickMapInfoField.Ignition,
                translationKey: 'dashboard.quick-map.info-window.ignition'
            },
            {
                value: DashboardQuickMapInfoField.Freezer,
                translationKey: 'dashboard.quick-map.info-window.freezer'
            },
            {
                value: DashboardQuickMapInfoField.Speed,
                translationKey: 'dashboard.quick-map.info-window.speed'
            },
            {
                value: DashboardQuickMapInfoField.Fuel,
                translationKey: 'dashboard.quick-map.info-window.fuel'
            },
            {
                value: DashboardQuickMapInfoField.EngineHours,
                translationKey: 'dashboard.quick-map.info-window.engine-hours'
            },
            {
                value: DashboardQuickMapInfoField.Driver,
                translationKey: 'dashboard.quick-map.info-window.driver'
            },
            {
                value: DashboardQuickMapInfoField.FuelCapStatus,
                translationKey: 'generic.params-map.fuel-cap-status'
            },
            {
                value: DashboardQuickMapInfoField.GpsBatteryLevel,
                translationKey: 'generic.params-map.battery-level'
            },
            {
                value: DashboardQuickMapInfoField.BatteryCurrent,
                translationKey: 'generic.params-map.battery-current'
            },
            {
                value: DashboardQuickMapInfoField.MotionTime,
                translationKey: 'generic.params-map.last-moving-time'
            },
        ];
    }
};
